const setCardMask = (gaps: Array<number>, lengths: Array<number>): string => {
  if (!gaps && !lengths) {
    return '#### #### #### ####';
  }

  const maxCardLength = lengths[lengths.length - 1];
  const mask = Array(maxCardLength).fill('#');
  gaps.forEach((gap, index) => mask.splice(gap + index, 0, ' '));
  return mask.join('');
};

const luhnCheck = (num: string): boolean => {
  const arr = num
    .split('')
    .reverse()
    .map((x) => parseInt(x));
  const lastDigit = arr.shift();
  let sum = arr.reduce(
    (acc, val, i) => (i % 2 !== 0 ? acc + val : acc + ((val *= 2) > 9 ? val - 9 : val)),
    0
  );
  sum += lastDigit;
  return sum % 10 === 0;
};

export { setCardMask, luhnCheck };
